import React, { Component } from 'react';
import { Alert } from 'react-bootstrap';
import PropTypes from 'prop-types';

class ErrorAlert extends Component {
  render() {
    const { error } = this.props;

    return (
      <Alert
        bsStyle={error.alert || 'danger'}
        onDismiss={this.props.closeError}
      >
        <p>
          {error.code ? error.code : ''}{' '}
          {error.title ? ' - ' + error.title : ''}
        </p>
        <h4>{error.message}</h4>
      </Alert>
    );
  }
}

ErrorAlert.propTypes = {
  closeError: PropTypes.func.isRequired,
  error: PropTypes.shape({
    title: PropTypes.string,
    code: PropTypes.string,
    message: PropTypes.string
  })
};

export default ErrorAlert;
